import React from "react";

import { PaymentMethodValues } from "types";

import styles from "./paymentMethodsDdl.module.scss";

type AchLabelProps = {
	data: PaymentMethodValues;
};

const AchLabel = ({ data }: AchLabelProps) => {
	return (
		<div className={styles.label}>
			<div className={styles.title}>
				{`${data?.bankAccountName} ${data?.routingNumber?.label}`}
			</div>
			<div className={styles.notes}>{data?.bankName}</div>
		</div>
	);
};

export default AchLabel;
